module.exports = __webpack_public_path__ + "static/media/studio_construction_telehandler_mt_935_manitou_003.b4d8fc14.png";